import React from 'react'
import { change, Field, reduxForm } from 'redux-form'
import AutoCompleteSelect from '../../../../../itrust_common/components/form/AutoCompleteSelect'
import { CountriesStates } from '../../../../../itrust_common/components/CountriesStates'
import { CurrencyCodeSymbol } from '../../../../../itrust_common/components/CurrencyCodeSymbol'
import { useDispatch } from 'react-redux'

export default function NewCountryForm(props) {
  const { handleSubmit } = props
  const dispatch = useDispatch()

  const handleSelectCountry = (country) => {
    let selectedCountryObj = CountriesStates.find(item => item.countryName === country)
    dispatch(change('newCountryForm', 'country_code', selectedCountryObj.countryShortCode))
    // currency symbol and code
    dispatch(change('newCountryForm', 'currency_symbol', CurrencyCodeSymbol[selectedCountryObj.countryShortCode].symbol))
    dispatch(change('newCountryForm', 'currency_code', CurrencyCodeSymbol[selectedCountryObj.countryShortCode].code))
  }

  return (
    <form onSubmit={handleSubmit} className='pb-6'>
      <Field
        name="country_name"
        label="Select Country"
        data={CountriesStates}
        textField="countryName"
        valueField="countryName"
        component={AutoCompleteSelect}
        wrapperClasses="col form-group error autocomplete mb-0"
        onChange={(e) => handleSelectCountry(e)}
      />
    </form>
  )
}

NewCountryForm = reduxForm({
  form: 'newCountryForm',
  enableReinitialize: true
})(NewCountryForm)